import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import FieldLabel from 'ui-library/inputs/FieldLabel';

interface UploadRawTextFormProps {
  autoFocus: boolean;
  error?: React.ReactNode;
  exampleImageURL: string;
  // Either raw text or HTML nodes rendering additional information.
  helpText?: JSX.Element | string;
  label?: string;
  onTextAreaChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  text?: string;
}

function UploadRawTextForm({
  autoFocus,
  error,
  exampleImageURL,
  helpText,
  label,
  onTextAreaChange,
  text,
}: UploadRawTextFormProps): JSX.Element {
  return (
    <div>
      <p>Enter comma-, semicolon-, or tab-separated text below. Pasting from Excel is supported.</p>
      {helpText}
      <img className="bulkImportModal-spreadsheetPreviewImage" src={exampleImageURL} />
      <div>
        {label && (
          <FieldLabel
            className="u-small-spacing-top"
            isRequired={true}
            label={label}
            labelStyle={FieldLabel.STYLES.LABEL}
          />
        )}
        <textarea
          autoFocus={autoFocus}
          className={classNames('bulkImportModal-textarea', {
            'u-border-danger': Boolean(error),
          })}
          onChange={onTextAreaChange}
          rows={5}
          value={text || ''}
          {...getTestProps({component: 'UploadRawTextForm', element: 'textarea'})}
        />
        <div className={classNames('u-danger-color', {'u-spacing-bottom': !error})}>{error}</div>
      </div>
    </div>
  );
}

UploadRawTextForm.defaultProps = {
  autoFocus: false,
};

export default UploadRawTextForm;
